import { breakpoints, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

export const SliderWrapper = styled.div`
  display: none;
  position: relative;

  @media (min-width: ${breakpoints.md}) {
    display: block;
  }
`;

export const Img = styled.img<{ isSelected: boolean; thumbSize?: string }>`
  cursor: pointer;
  display: block;
  width: ${({ thumbSize }) => thumbSize || '8.75rem'} !important;
  height: ${({ thumbSize }) => thumbSize || '8.75rem'} !important;
  object-fit: cover;
  overflow: hidden;
  border-radius: 0.25rem;
  opacity: ${({ isSelected }) => (isSelected ? 1 : 0.5)};
`;

export const Div = styled.div`
  line-height: 1rem;
  position: relative;
  margin-bottom: 0.3125rem;

  cursor: pointer;
  text-align: center;
  mix-blend-mode: multiply;

  &:focus-visible {
    outline: 2px solid ${theme.color.border.selected};
    outline-offset: 2px;
    border-radius: 0.25rem;
  }
`;

export const TopMostDiv = styled.div`
  position: relative;
  border-radius: 0.25rem;
  background-color: ${theme.color.background.disabled};
`;

export const Border = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  border: 2px solid ${theme.color.border.selected};
  border-radius: 0.25rem;
`;

export const VideoIcon = styled.div`
  opacity: 0.8;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
